import type { FieldPath, FieldValues } from 'react-hook-form'
import type { Style } from 'inlines'
import { MultiLineTextInput } from '../../input/text/MultiLineTextInput'
import { FormField } from '../FormField'
import { useFieldRequired } from '../formSchemaContext'

export type TextAreaFieldProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  labelStyle?: Style
  required?: boolean
  placeholder?: string
  minHeight?: string
  style?: Style
}

export const TextAreaField = <T extends FieldValues = FieldValues>({
  name,
  required,
  ...inputProps
}: TextAreaFieldProps<T>) => {
  const fieldRequired = useFieldRequired(name)
  const isRequired = required ?? fieldRequired

  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, onBlur, errorMessage }) => (
        <MultiLineTextInput
          {...inputProps}
          required={isRequired}
          value={(value as string) ?? ''}
          setValue={onChange}
          onBlur={onBlur}
          errorMessage={errorMessage}
        />
      )}
    />
  )
}
